import { Link } from "react-router-dom";
import { researchPillars } from "../data/researchPillars";

const pillarById = Object.fromEntries(
  researchPillars.map((pillar) => [pillar.id, pillar]),
);

/** Links to Home project view filtered by agenda pillar. */
const PillarChips = ({ pillarIds = [] }) => {
  if (!pillarIds.length) return null;

  return (
    <div className="mt-2 flex flex-wrap gap-1.5">
      {pillarIds.map((id) => {
        const pillar = pillarById[id];
        if (!pillar) return null;
        return (
          <Link
            key={id}
            to={`/home?view=projects&pillar=${id}`}
            className="rounded-full border border-gray-300 px-2 py-0.5 text-sm text-gray-600 transition-colors hover:border-green hover:text-green dark:hover:text-green-dark dark:border-gray-600 dark:text-gray-400 dark:hover:border-green dark:hover:text-green-dark"
            title={pillar.title}
          >
            {pillar.bigGoal || pillar.title}
          </Link>
        );
      })}
    </div>
  );
};

export default PillarChips;
